import { TFunction } from 'i18next';
import { StepConfigItem } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';
import StepperForm1 from './components/step1';
import StepperForm2 from './components/step2';

export const BookAppointmentConfig = (t: TFunction): StepConfigItem[] => {
  return [
    {
      step1: {
        component: <StepperForm1 callStepSpecificAction={true} />,
        step: 0,
        footerNavigationProps: {
          fullWidth: true,
          buttonTitle: t('stepperFormTradeIn.next'),
        },
      },
    },
    {
      step2: {
        component: <StepperForm2 />,
        step: 1,

        footerNavigationProps: {
          fullWidth: true,
          backNavigation: false,
          buttonTitle: t('bookTestDrive.booktestDriveLbl'),
        },
      },
    },
  ];
};
